var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "video-wrapper" }, [
    _c("div", { staticClass: "input-area" }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.videoUrl,
            expression: "videoUrl",
          },
        ],
        attrs: { rows: "4", cols: "50", type: "textarea" },
        domProps: { value: _vm.videoUrl },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.videoUrl = $event.target.value
          },
        },
      }),
      _c("button", { attrs: { color: "blue" }, on: { click: _vm.reload } }, [
        _vm._v(_vm._s(_vm.$t("Reload"))),
      ]),
    ]),
    _c(
      "video",
      {
        attrs: {
          width: "520",
          auto: "",
          muted: "",
          controls: "",
          id: "replay-video",
        },
        domProps: { muted: true },
      },
      [
        _c("source", { attrs: { src: _vm.videoUrl, type: "video/mp4" } }),
        _vm._v(
          " " +
            _vm._s(_vm.$t("Your browser does not support the video tag")) +
            " "
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }